import { Form, Checkbox, Col, Row } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import InputDecimal from '../../InputDecimal';
import SectionCard from '../../SectionCard';

interface Props {
  prefixPath?: string[];
}

export default function GovernmentProcurementFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  const form = Form.useFormInstance();
  const enableGov = Form.useWatch('enableGov', form);

  return (
    <>
      {/* ===== Compras Governamentais (UB82a..UB82g) ===== */}
      <div>
        <Form.Item name="enableGov" valuePropName="checked">
          <Checkbox style={{ fontWeight: 600 }}>
            Exibir Grupo Compras Governamentais
          </Checkbox>
        </Form.Item>
      </div>

      <SectionCard
        visible={enableGov}
        title="Compras Governamentais - Composição do valor"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota IBS-UF (%)"
              name={[...prefixPath, 'govPurchaseIbsUfAliquotPercentage']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor Tributo IBS-UF"
              name={[...prefixPath, 'govPurchaseIbsUfValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota IBS-Mun (%)"
              name={[...prefixPath, 'govPurchaseIbsMunicipalAliquotPercentage']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Tributo IBS-Mun"
              name={[...prefixPath, 'govPurchaseIbsMunicipalValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota da CBS (%)"
              name={[...prefixPath, 'govPurchaseCbsAliquotPercentage']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Tributo CBS"
              name={[...prefixPath, 'govPurchaseCbsValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>
    </>
  );
}
